<template>
    <div class="change-order-status">
        <b-dropdown aria-role="list" position="is-bottom-left">
            <button class="button is-small" :class="currentStatus.style" slot="trigger">
                <b-icon :icon="currentStatus.icon"/>
                <span class="is-hidden-touch">{{ currentStatus.name }}</span>
                <b-icon icon="angle-down"/>
            </button>

            <b-dropdown-item aria-role="listitem" v-for="(statusListItem, key) in statusList" :key="key"
                             @click="changeStatus(key)">
                {{ statusListItem.name }}
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
    import database from "@/services/database";

    export default {

        name: "changeOrderStatus",

        props: {
            id: {
                required: true
            },
            setStatus: {
                default: 'pending'
            }
        },

        computed: {
            currentStatus() {
                if (this.statusList[this.status]) {
                    return this.statusList[this.status];
                }

                return this.statusList.pending;
            }
        },

        data() {
            return {
                status: this.setStatus,
                statusList: {
                    pending: {
                        name: 'Aguardando',
                        icon: 'minus',
                        style: 'is-warning'
                    },
                    concluded: {
                        name: 'Concluído',
                        icon: 'check',
                        style: 'is-success'
                    }
                }
            }
        },

        watch: {
            setStatus(status) {
                this.status = status;
            }
        },

        methods: {
            async changeStatus(newStatus) {
                const loading = this.$buefy.loading.open();
                await database.collection('orders').doc(this.id).set({status: newStatus}, {merge: true})
                this.status = newStatus;
                loading.close();
            },
        }

    }
</script>
